module.exports = __webpack_public_path__ + "static/media/sip-logo-white.83ef404e.png";